import { styled } from '@nykaa/ui-components';

export const DeltaCommunicationContainer = styled.div<{
  isDetailsView: boolean;
  backgroundColor: string;
}>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ theme, backgroundColor }) => `background-color: ${
    backgroundColor || theme.colors.secondary10
  };
    border-radius: 0 0 ${theme.borders.radius10} ${theme.borders.radius10};
    overflow: hidden;
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80};`};
  ${({ theme, isDetailsView }) =>
    isDetailsView &&
    `margin-top: ${theme.spacing.spacing80}; border-radius: ${theme.borders.radius10};`};
`;

export const DeltaCommunicationMet = styled.div<{ isDetailsView: boolean; successColor: string }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ theme, successColor }) => `background-color: ${successColor || theme.colors.info10};
    border-radius: 0 ${theme.borders.radius10};
    overflow: hidden;
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80};`};
  ${({ theme, isDetailsView }) =>
    isDetailsView &&
    `margin-top: ${theme.spacing.spacing80}; border-radius: ${theme.borders.radius10};`};
`;

export const DeltaCommunicationMetText = styled.div<{ successTextColor: string }>`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme, successTextColor }) => `color: ${successTextColor || theme.colors.info};`};
`;

export const OfferAppliedWrapper = styled.div<{
  textColor: string;
  backgroundColor: string;
  isDetailsView: boolean;
}>`
  ${({ theme, backgroundColor }) => `background-color: ${backgroundColor};
    border-radius: 0 0 ${theme.borders.radius10} ${theme.borders.radius10};
    overflow: hidden;
    display: flex;
    width: 100%;
    padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80};`};
  span {
    ${({ theme, textColor }) =>
      `color: ${textColor || theme.colors.positive}; margin-left: ${theme.spacing.spacing20};`};
    ${({ theme }) => theme.typography.buttonSmall};
  }
  ${({ theme, isDetailsView }) =>
    isDetailsView &&
    `margin-top: ${theme.spacing.spacing80}; border-radius: ${theme.borders.radius10};`};
`;

export const DeltaCommunicationText = styled.div<{ textColor: string }>`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme, textColor }) => `color: ${textColor || theme.colors.secondary};`};
`;

export const RightArrowWrapper = styled.div`
  height: 16px;
  width: 16px;
`;
